import { render, staticRenderFns } from "./signatures-rams.vue?vue&type=template&id=644df574"
import script from "./signatures-rams.vue?vue&type=script&lang=js"
export * from "./signatures-rams.vue?vue&type=script&lang=js"
import style0 from "./signatures-rams.vue?vue&type=style&index=0&id=644df574&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports